// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eWGV","right":"styles_right__2ZtWJ"};